import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {TextField, Box, Typography} from '@mui/material';
import { productividadResources } from '../endpoints';

export default function TablaProductividadPorCliente() {
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [loading, setLoading] = React.useState(false);
    const [search, setSearch] = React.useState("");

    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10,
    });

    React.useEffect(() => {
        let active = true;

        const fetchData = async () => {
            setLoading(true);
            try {
                // Enviar page+1 porque la API usa 1-based index para page
                const response = await productividadResources.getProductividadPorcliente({
                    page: paginationModel.page + 1,
                    size: paginationModel.pageSize,
                    search,
                });

                if (!response.ok) throw new Error('Error en la petición');
                const data = await response.json();

                if (!active) return;

                setRows(data.items);
                setRowCount(data.total);
            } catch (error) {
                console.error(error);
            } finally {
                if (active) setLoading(false);
            }
        };

        fetchData();

        return () => {
            active = false;
        };
    }, [paginationModel, search]);

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setPaginationModel((prev) => ({
            ...prev,
            page: 0, // Resetear a primera página cuando cambie búsqueda
        }));
    };

    const columns = [
        { headerName: 'Cliente', field: 'cliente', width: 300},
        { headerName: 'Productividad Sala (x̄)', field: 'productividad_sala',  type: 'number', width: 300},
        { headerName: 'Productividad Bodega (x̄)', field: 'productividad_bodega',  type: 'number', width: 300},
        { headerName: 'Productividad Altillo (x̄)', field: 'productividad_altillo',  type: 'number', width: 300},
        { headerName: 'Productividad Visual (x̄)', field: 'productividad_visual',  type: 'number', width: 300},
        { headerName: 'Productividad Trastienda (x̄)', field: 'productividad_trastienda',  type: 'number', width: 300},
    ];

    return (
        <Box sx={{border: '2px solid #444444',borderRadius: 2,overflowY: 'auto',boxSizing: 'border-box',
            p: 2,  width: '100%', display: 'inline-block' }}>
            <Typography variant="h6" component="h2" sx={{ mb: 2 , marginBottom:3}}>
                Productividad por cliente
            </Typography>
            <TextField
                label="Buscar por cliente"
                variant="outlined"
                size="small"
                value={search}
                onChange={handleSearchChange}
                sx={{ mb: 2 }}
            />
            <DataGrid
                autoHeight={true}
                rows={rows}
                columns={columns}
                pagination
                paginationMode="server"
                pageSizeOptions={[10, 25, 50]}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                rowCount={rowCount}
                rowsPerPageOptions={[10, 25, 50]}
                loading={loading}
                disableColumnMenu
                getRowId={(row) => row.id_cliente}
                getRowHeight={() => 50}
            />
        </Box>
    );
}